import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import Edit from "@material-ui/icons/Edit";
import UserRoles from "../../constants/UserRoles";

export default class BusinessCards extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Business_Cards._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.filter_status = 'all';
		this.state.current_address = null;
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.filter_status && this.state.filter_status && (prevState.filter_status !== this.state.filter_status)) {
			await this.fetchData();
		}
		if (prevState.current_address !== this.state.current_address && this.state.current_address) {
			if (typeof this.props.setCurrentAddress === 'function') {
				this.props.setCurrentAddress(this.state.current_address)
			}
		}
	}

    fetchData = async () => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.selfOnly = ![UserRoles.Admin, UserRoles.Executive].includes(this.props.main_role);
		this.state.filter.status = this.props.main_role === UserRoles.Admin ? this.state.filter_status : 'all';
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(null, ['current_address']);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const isAdmin = this.props.main_role === UserRoles.Admin;
		let columns = [
			{
				Header: "Requested By",
				id: "users.name_first",
				width: 175,
				accessor: obj => obj.creator,
			},
			{
				Header: "Created",
				id: "created",
				width: 175,
				accessor: obj =>
					moment(obj.created).tz('America/Phoenix').format('MM/DD/YYYY hh:mm A'),
			},
			{
				Header: "Address",
				id: "requested_address",
				accessor: obj => obj.requested_address,
			},
		];
		if (isAdmin) {
			columns.push({
				Header: "Status",
				id: "approved",
				width: 100,
				accessor: obj => obj.status,
			});
		}
		columns.push({
				Header: "Sent",
				id: "sent",
				width: 100,
				accessor: obj => obj.sent ? "Yes" : "No",
			});

		if (!this.props.read_only) {
			columns.push({
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<span>
							<Link to={"/business_cards/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={"small"} />
								</Button>
							</Link>
						</span>
					);
				},
			});
		}
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Business Cards')}
							{!this.props.read_only && this.props.main_role === UserRoles.Admin &&
								<ButtonGroup>
									<Button
										onClick={() => {
											this.setState({filter_status: 'all'})
										}}
										outline={this.state.filter_status !== 'all'}
										active={this.state.filter_status === 'all'}
										color={'info'}
									>
										All
									</Button>
									<Button
										onClick={() => {
											this.setState({filter_status: 'pending'})
										}}
										outline={this.state.filter_status !== 'pending'}
										active={this.state.filter_status === 'pending'}
										color={'info'}
									>
										Pending
									</Button>
									<Button
										onClick={() => {
											this.setState({filter_status: 'approved'})
										}}
										outline={this.state.filter_status !== 'approved'}
										active={this.state.filter_status === 'approved'}
										color={'info'}
									>
										Approved
									</Button>
									<Button
										onClick={() => {
											this.setState({filter_status: 'denied'})
										}}
										outline={this.state.filter_status !== 'denied'}
										active={this.state.filter_status === 'denied'}
										color={'info'}
									>
										Denied
									</Button>
								</ButtonGroup>
							}
							{this.renderHeaderRight("BusinessCards", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
